"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const VmwareActionNodeValidation_1 = require("../validations/VmwareActionNodeValidation");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
const utils_1 = require("../helper/utils");
class VmwareActionNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.VMWARE_ACTION };
    if (props.type !== types_1.NODE_TYPES.VMWARE_ACTION)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        action: "",
        params: {}
      };
    return nodeData;
  }
  serialize(uiData) {
    return uiData;
  }
  validate() {
    return new VmwareActionNodeValidation_1.VmwareActionNodeValidation().validate(
      this
    );
  }
  async getAvailableResources() {
    let availableResources = [];
    const nodeData = this.getNodeData();
    if (nodeData) {
      let action = nodeData.action;
      let sgcData = await utils_1.getSgcData(
        this.getDataResolver(),
        `${cloudProvider_1.default.VMWARE}/actions.json`
      );
      let rec = sgcData.find(u => u.service === action);
      let label = rec ? rec.displayService : "";
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: "",
        label: [this.getNodeName(), label].join("."),
        context: {
          outputPath: ""
        }
      });
    }
    return availableResources;
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.VMWARE;
  }
}
exports.VmwareActionNode = VmwareActionNode;
//# sourceMappingURL=VmwareActionNode.js.map
